"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserAccountResponse = void 0;
exports.mockUserAccountResponse = {
    first_name: 'Mock',
    last_name: 'User',
    email: 'mock@getflex.com',
    phone_number: '18888889999',
    customer_public_id: 'ASDFG12345HJKLL09876',
    email_verified: false,
};
